export enum InteractionSeverity {
    Minor = 1,  //Blue
    Moderate = 2, //Yellow
    Major = 3, //Red
}
